import { RadioGroup } from "@headlessui/react";
import { useEffect, useState } from "react";
import {
  bankAccountOptionsFiltered,
  typeBankAccountOptions,
} from "../../utils/options_selects";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function FormBankAccount({
  _state = {
    bankAccount: "",
    typeBankAccount: "",
    accountNumber: "",
    parent: false,
  },
  setState,
  errorField,
}) {
  const [parent, setParent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ..._state, [name]: value });
  };

  const handleChangeRadio = (value) => {
    setParent(value);
    setState({ ..._state, parent: value });
  };

  const handleChangeSelect = (e) => {
    const { name, value } = e.target;
    setState({ ..._state, [name]: value });
  };

  useEffect(() => {}, [errorField]);

  return (
    <form action="#" method="POST">
      <div className="mt-3 bg-white">
        <div className="">
          <div className="mt-4">
            <label htmlFor="bankAccount" className="block font-bold">
              Banco
            </label>
            {bankAccountOptionsFiltered && (
              <select
                required
                onChange={(choice) => handleChangeSelect(choice)}
                id="bankAccount"
                name="bankAccount"
                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
              >
                {bankAccountOptionsFiltered.map((item, index) => (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                ))}
              </select>
            )}
            {errorField.bankAccount && (
              <span
                className="text-sm"
                style={{ color: "#fc3e58", fontStyle: "italic", paddingTop: 0 }}
              >
                {errorField.bankAccount}
              </span>
            )}
          </div>
          <div className=" mt-4">
            <label htmlFor="typeBankAccount" className="block font-bold">
              Tipo de cuenta
            </label>

            {typeBankAccountOptions && (
              <select
                required
                onChange={(choice) => handleChangeSelect(choice)}
                id="typeBankAccount"
                name="typeBankAccount"
                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0"
              >
                {typeBankAccountOptions.map((item, index) => (
                  <option key={index}>{item.label}</option>
                ))}
              </select>
            )}
            {errorField.typeBankAccount && (
              <span
                className="text-sm"
                style={{
                  color: "#fc3e58",
                  fontStyle: "italic",
                  textAlign: "left",
                  paddingTop: 0,
                }}
              >
                {errorField.typeBankAccount}
              </span>
            )}
          </div>

          <div className="mt-4">
            <label htmlFor="accountNumber" className="block font-bold">
              Número de cuenta
            </label>
            <div>
              <input
                value={_state.accountNumber}
                onChange={handleChange}
                type="number"
                name="accountNumber"
                id="accountNumber"
                maxLength="40"
                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0"
              />
            </div>

            {errorField.accountNumber && (
              <span
                className="text-sm"
                style={{
                  color: "#fc3e58",
                  fontStyle: "italic",
                  paddingBottom: 0,
                }}
              >
                {errorField.accountNumber ?? ""}
              </span>
            )}
          </div>

          {/* <div
            className="col-span-8 sm:col-span-4 mt-4"
          >
            <div>
              <RadioGroup value={parent} onChange={handleChangeRadio}>
                <RadioGroup.Label className="block font-bold">
                  {" "}
                  ¿Deseas elegir esta cuenta para tus próximos desembolsos?
                </RadioGroup.Label>
                <div
                  className="flex gap-4"
                >
                  <RadioGroup.Option
                    className={({ checked, active }) =>
                      classNames(
                        checked
                          ? "border-transparent"
                          : "border-purpleLight border-2",
                        active ? "border-purple border-2" : "",
                        "relative border-2 rounded-lg shadow-sm px-2 py-1 flex cursor-pointer min-w-16"
                      )
                    }
                    value={true}
                  >
                    {({ checked, active }) => (
                      <>
                        <span className={checked ? "bg-blue-200" : ""}>Sí</span>
                        <CheckCircleIcon
                          className={classNames(
                            !checked ? "invisible" : "",
                            "h-6 w-6 text-green absolute right-0 pr-1"
                          )}
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            active ? "border-purple border-2" : "border-2",
                            checked ? "border-purple" : "border-transparent",
                            "absolute -inset-px rounded-lg pointer-events-none"
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </RadioGroup.Option>

                  <RadioGroup.Option
                    value={false}
                    className={({ checked, active }) =>
                      classNames(
                        checked
                          ? "border-transparent"
                          : "border-purpleLight border-2 w-10",
                        active ? "border-purple border-2" : " w-10",
                        "relative border-2 rounded-lg shadow-sm px-2 py-1 flex cursor-pointer  w-16"
                      )
                    }
                  >
                    {({ checked, active }) => (
                      <>
                        <span>No</span>

                        <CheckCircleIcon
                          className={classNames(
                            !checked ? "invisible" : "",
                            "h-6 w-6 text-green absolute right-0 pr-1"
                          )}
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            active ? "border-purple border-2" : "border-2",
                            checked ? "border-purple" : "border-transparent",
                            "absolute -inset-px rounded-lg pointer-events-none"
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </RadioGroup.Option>
                </div>
              </RadioGroup>
            </div>

            {errorField.parent && (
              <span
                className="text-sm"
                style={{
                  color: "#fc3e58",
                  fontStyle: "italic",
                  textAlign: "left",
                  paddingTop: 0,
                }}
              >
                {errorField.parent}
              </span>
            )}
          </div>
           */}
        </div>
      </div>
    </form>
  );
}
